import React from 'react';
import { Clock, ChevronRight, Trophy } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';

export const PredictionHistory = ({ history }) => (
  <Card className="bg-gray-900 border-gray-800" data-testid="prediction-history">
    <CardHeader>
      <CardTitle className="text-white flex items-center gap-2">
        <Clock size={18} className="text-cyan-400" />
        Historial de Predicciones
      </CardTitle>
      <CardDescription className="text-gray-500">Ultimas 30 predicciones generadas</CardDescription>
    </CardHeader>
    <CardContent>
      {history.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          <Clock size={32} className="mx-auto mb-3 opacity-50" />
          <p>Sin predicciones aun. Genera la primera!</p>
        </div>
      ) : (
        <div className="space-y-3 max-h-[500px] overflow-y-auto pr-1">
          {history.map((p, idx) => (
            <div key={p.id || `hist-${idx}`} className="flex items-center justify-between p-3 rounded-lg bg-gray-800/50 border border-gray-700/30 hover:bg-gray-800 transition-colors">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-purple-500/20 flex items-center justify-center">
                  <Trophy size={18} className="text-purple-400" />
                </div>
                <div>
                  <p className="text-white font-medium">{p.lottery_name || p.lottery_id}</p>
                  <p className="text-gray-500 text-xs">{p.date || new Date(p.created_at).toLocaleDateString('es-DO')}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="flex gap-1.5">
                  {p.numbers?.map((n, i) => (
                    <span key={`hnum-${i}`} className="w-8 h-8 rounded-full bg-gradient-to-br from-cyan-500/30 to-blue-600/30 border border-cyan-500/30 flex items-center justify-center text-white text-xs font-bold">
                      {n}
                    </span>
                  ))}
                </div>
                <Badge className={`text-xs ${
                  (p.confidence || 0) >= 0.8 ? 'bg-green-500/20 text-green-400'
                  : (p.confidence || 0) >= 0.5 ? 'bg-amber-500/20 text-amber-400'
                  : 'bg-red-500/20 text-red-400'
                }`}>
                  {((p.confidence || 0) * 100).toFixed(0)}%
                </Badge>
                <ChevronRight size={16} className="text-gray-600" />
              </div>
            </div>
          ))}
        </div>
      )}
    </CardContent>
  </Card>
);
